var app = angular.module("leonardo");

var HomeState = function($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise(function($injector) {
    var $state = $injector.get("$state");
    $state.go("home");
  });

  $stateProvider.state('home', {
    url: "/home?token&errorSSO&session_id",
    parent: 'layout-no-cols',
    cssClass: 'page-home',
    views: {
      // 'user': { templateUrl: 'views/templates/user/request.html' },
      'content': { templateUrl: 'views/templates/user/home.html' }
    },
    public: true
  });

  $stateProvider.state('forgot_password', {
    url: "/forgot-password",
    parent: 'layout-no-cols',
    cssClass: 'page-home',
    views: {
      'user': { templateUrl: 'views/templates/user/login.html' },
      'content': { templateUrl: 'views/templates/user/forgot-password.html' }
    },
    public: true
  });

  $stateProvider.state('password_reset', {
    url: "/reset-password/:uidb64/:token",
    parent: 'layout-no-cols',
    cssClass: 'page-home',
    views: {
      'content': {
        controller: "ResetPasswordController",
        templateUrl: "views/templates/user/password-reset.html"
      }
    },
    public: true
  });

  $stateProvider.state('password_create', {
    url: "/create-password/:uidb64/:token",
    parent: 'layout-no-cols',
    cssClass: 'page-home',
    views: {
      'content': {
        controller: "ResetPasswordController",
        templateUrl: "views/templates/user/password-create.html"
      }
    },
    public: true
  });
};

app.config(['$stateProvider', '$urlRouterProvider', HomeState]);
